// Module
var code = "<template> <require from=\"app/cm/components/household/care-team-grid\"></require> <care-team-grid household-case-id.bind=\"householdCaseId\"></care-team-grid> </template> ";
// Exports
module.exports = code;